import React, { useEffect, useState } from "react";
import axios from "axios";
import { alertErrorMessage, alertSuccessMessage, confirmDelete } from "../../components/alert";
import {
  Container,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Pagination,
  Card,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";



export default function ExamPapersUI() {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [questionEntryTypes, setQuestionEntryTypes] = useState([]);
  const [examMastersModal, setExamMastersModal] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [academicYear, setAcademicYear] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [examPapers, setExamPapers] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paperCodes, setPaperCodes] = useState([]);

  const [editExamMasters, setEditExamMasters] = useState([]);
  const [editExamPapers, setEditExamPapers] = useState([]);

  const today = new Date().toISOString().split("T")[0];

  const navigate = useNavigate();

  const [editData, setEditData] = useState({
    title: "",
    exam_master: "",
    paper_code_id: "",
    subject: "",
    number_of_questions: "",
    exam_paper: "",
    exam_paper_type: "",
    academic_year: "",
    exam_date: today,
    exam_start_time: "",
    exam_end_time: "",
    id: "",
  });

  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const token = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    title: "",
    exam_master: "",
    paper_code_id: "",
    subject: "",
    number_of_questions: "",
    exam_paper: "",
    exam_paper_type: "",
    academic_year: "",
    exam_date: today,
    exam_start_time: "",
    exam_end_time: "",
    id: "",
  });

  useEffect(() => {
    fetchPrograms();
    fetchSemesters();
    fetchCourseCategories();
    fetchAssignments(1);
    // fetchExamPapers();
    fetchAcademicYear();
  }, []);

  const [searchFilter, setSearchFilter] = useState({
    search_key: "",
    academic_year: "",
    program: "",
    courseCategory: "",
    semester: "",
    subject: "",
    paperCode: "",
    exam_paper_type: "",
    exam_master: "",
    exam_paper: "",
    exam_from_date: "",
    exam_to_date: "",
  });

  const fetchPaperCodes = async (subjectId, semesterId) => {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/paperCodes",
      { subject: subjectId, semester: semesterId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setPaperCodes(res.data.data);
    else setPaperCodes([]);
  };

  const fetchAssignments = async (pageNo) => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchAssignmets",
        {
          page: pageNo,
          perpage: perPage,
          searchParam: {
            search_key: searchFilter.search_key,
            academic_year: searchFilter.academic_year,
            program: searchFilter.program,
            course_category: searchFilter.courseCategory,
            semester: searchFilter.semester,
            subject: searchFilter.subject,
            paper_code: searchFilter.paperCode,
            exam_paper_type: searchFilter.exam_paper_type,
            exam_master: searchFilter.exam_master,
            exam_paper: searchFilter.exam_paper,
            exam_from_date: searchFilter.exam_from_date,
            exam_to_date: searchFilter.exam_to_date,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const resData = response.data.data;
      setAssignments(resData.assignments);
      setTotalPages(resData.pagination.last_page);
    } catch (error) {
      console.error("Error fetching assignments:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setSearchFilter({
      search_key: "",
      academic_year: "",
      subject: "",
      semester: "",
      exam_paper_type: "",
      exam_master: "",
      exam_paper: "",
      exam_from_date: "",
      exam_to_date: "",
    });
    setPage(1); // reset to first page
    fetchAssignments(1, perPage, {
      search_key: "",
      academic_year: "",
      subject: "",
      semester: "",
      exam_paper_type: "",
      exam_master: "",
      exam_paper: "",
      exam_from_date: "",
      exam_to_date: "",
    });
  };

  useEffect(() => {
    fetchAssignments(page);
  }, [page]);

  const fetchExamPapers = async (examMasterId) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPapers",
        {
          page: 1,
          perpage: 10,
          searchParam: {
            exam_master: examMasterId, // ✅ pass selected exam_master id here
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status) {
        setExamPapers(res.data.data.exammasters || []);
      }
    } catch (error) {
      console.error("Failed to fetch exam papers:", error);
    }
  };

  useEffect(() => {
    if (formData.exam_master) {
      fetchExamPapers(formData.exam_master);
    }
  }, [formData.exam_master]);

  useEffect(() => {
    if (formData.exam_paper_type) {
      fetchExamMastersForDropdown();
    }
  }, [formData.exam_paper_type]);

  const fetchExamMastersForDropdown = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamMaster",
        {
          searchParam: {
            exam_paper_type: formData.exam_paper_type, // 👈 selected id
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.status) {
        const masters = res.data.data ?? []; // fallback to []
        setExamMastersModal(masters);
      } else {
        setExamMastersModal([]); // clear if status is false
      }
    } catch (err) {
      console.error("Error fetching exam masters:", err);
    }
  };

  const fetchSemesters = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/semesters",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setSemesters(res.data.data.semesters);
  };

  const fetchSubjects = async (courseCategoryId) => {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/subjects",
      { course_category: courseCategoryId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setSubjects(res.data.data);
  };

  const fetchPrograms = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/programs",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setPrograms(res.data.data.programs);
  };

  const fetchAcademicYear = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/fetchAcademicYears",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setAcademicYear(res.data.data);
  };

  const fetchCourseCategories = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/courseCategories",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setCourseCategories(res.data.data.courseCategories);
  };

  const handleSubjectOrSemesterChange = (name, value) => {
    const updated = { ...searchFilter, [name]: value };
    setSearchFilter(updated);

    if (name === "subject" || name === "semester") {
      if (updated.subject && updated.semester) {
        fetchPaperCodes(updated.subject, updated.semester);
      }
    }
  };

  const handleCourseCategoryChange = (e) => {
    const value = e.target.value;
    setSearchFilter({ ...searchFilter, courseCategory: value, subject: "" });
    fetchSubjects(value);
  };

  const addAssignment = async () => {
    try {
      const payload = {
        academic_year: formData.academic_year,
        title: formData.title,
        subject: formData.subject,
        semester: formData.semester, // make sure you add this in state if needed
        exam_paper_type: formData.exam_paper_type, // make sure in state
        exam_master: formData.exam_master,
        exam_paper: formData.exam_paper,
        exam_date: formData.exam_date, // yyyy-mm-dd
        exam_start_time: formData.exam_start_time, // HH:mm
        exam_end_time: formData.exam_end_time, // HH:mm
        id: formData.id || "", // only pass if editing
      };

      const token = localStorage.getItem("token");

      console.log("📤 Payload being sent:", payload);
      console.log("🔑 Token being sent:", token);

      const response = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/addEditAssignment",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("📥 API Response:", response.data);

      if (response.data.status) {
        alertSuccessMessage(response.data.message);

        setFormData({
          title: "",
          exam_master: "",
          paper_code_id: "",
          subject: "",
          question_entry_type: "",
          number_of_questions: "",
          exam_paper: "",
          academic_year: "",
          exam_date: today,
          exam_start_time: "",
          exam_end_time: "",
          id: "",
        });

        await fetchAssignments(page); // or current page number

        setShowModal(false); // then close modal
      } else {
        alertErrorMessage(response.data.message);
      }
    } catch (error) {
      alertErrorMessage(
        error.response?.data?.message || "Something went wrong!"
      );
    }
  };

  const fetchAssignmentsById = async (id) => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        page: "1",
        perpage: "10",
        id: id,
        searchParam: {
          search_key: "",
          academic_year: "",
          subject: "",
          semester: "",
          exam_paper_type: "",
          exam_master: "",
          exam_paper: "",
          exam_from_date: "",
          exam_to_date: "",
        },
      };

      const response = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchAssignmets",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        const assignment = response.data.data; // just data, not array

        if (assignment) {
          // fetch subjects for the assignment's program_category
          const subjectsRes = await axios.post(
            "https://codydealms.codydeasoftech.in/api/teacher/subjects",
            { course_category: assignment.program_category },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          if (subjectsRes.data.status) {
            setSubjects(subjectsRes.data.data); // populate subjects dropdown
          }

          // now set edit data
          setEditData({
            ...assignment,
            subject: assignment.subject, // numeric ID for preselection
          });
          setShowEditModal(true); // open modal
        } else {
          alertErrorMessage("No assignment found for this ID!");
        }
      } else {
        alertErrorMessage(response.data.message);
      }
    } catch (error) {
      alertErrorMessage(
        error.response?.data?.message || "Failed to fetch data!"
      );
    }
  };


  const deleteAssignment = (id) => {
  const token = localStorage.getItem("token");

  confirmDelete(async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/deleteAssignment",
        { id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLoading(false);

      if (response.data.status) {
        alertSuccessMessage(response.data.message);
        await fetchAssignments(page); // Refresh the list
      } else {
        alertErrorMessage(response.data.message);
      }
    } catch (error) {
      setLoading(false);
      alertErrorMessage(error.response?.data?.message || "Something went wrong!");
    }
  });
};


const navigateToDetails = (id) => {
  navigate(`/answers/${id}`);
};



  useEffect(() => {
    if (showModal || showEditModal) {
      fetchPrograms();
      // fetchExamMasters();
      fetchSemesters();
      fetchAcademicYear();
      fetchCourseCategories();
      // fetchExamMastersForDropdown() ;
      fetchSubjects();
    }
  }, []);

  useEffect(() => {
    if (showModal || showEditModal) {
      const fetchQuestionEntryTypes = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await axios.get(
            "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPaperTypes",
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (res.data.status) {
            setQuestionEntryTypes(res.data.data);
          } else {
            setQuestionEntryTypes([]);
          }
        } catch (err) {
          console.error("Failed to fetch question entry types:", err);
        }
      };

      fetchQuestionEntryTypes();
    }
  }, [showModal, showEditModal]);

  const editAssignment = async () => {
    if (!editData) return;

    const token = localStorage.getItem("token");
    const start_time = editData.exam_start_time.slice(0, 5);
    const end_time = editData.exam_end_time.slice(0, 5);
    const academic_year = Number(editData.academic_year_id);

    const payload = {
      id: editData.id, // important for edit
      academic_year: academic_year,
      title: editData.title,
      subject: editData.subject,
      semester: editData.semester,
      exam_paper_type: editData.exam_paper_type,
      exam_master: editData.exam_master,
      exam_paper: editData.exam_paper,
      exam_date: editData.exam_date,
      exam_start_time: start_time,
      exam_end_time: end_time,
    };

    console.log("🔹 Payload being sent to API:", payload);
    console.log("🔹 Authorization Token:", token);

    try {
      const response = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/addEditAssignment",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API Response:", response.data);

      if (response.data.status) {
        alertSuccessMessage("Assignment updated successfully!");

        await fetchAssignments(page);
        setShowEditModal(false);
      } else {
        alertErrorMessage(response.data.message);
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error);
      alertErrorMessage(
        error.response?.data?.message || "Failed to update assignment!"
      );
    }
  };

  // Fetch Masters for Edit
  const fetchEditExamMasters = async (examPaperTypeId) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamMaster",
        { searchParam: { exam_paper_type: examPaperTypeId } },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.status) {
        setEditExamMasters(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching exam masters (edit):", err);
    }
  };

  // Fetch Papers for Edit
  const fetchEditExamPapers = async (examMasterId, page = 1, perpage = 10) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPapers",
        {
          page, // ✅ required field
          perpage,
          searchParam: {
            exam_master: examMasterId,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.status) {
        // adjust according to actual API response
        setEditExamPapers(
          res.data.data.exammasters || res.data.data.papers || []
        );
      }
    } catch (err) {
      console.error("Error fetching exam papers (edit):", err);
    }
  };

  // Auto-fetch masters when exam_paper_type changes
  useEffect(() => {
    if (editData.exam_paper_type) {
      fetchEditExamMasters(editData.exam_paper_type);
    }
  }, [editData.exam_paper_type]);

  // Auto-fetch papers when exam_master changes
  useEffect(() => {
    if (editData.exam_master) {
      fetchEditExamPapers(editData.exam_master);
    }
  }, [editData.exam_master]);


if (loading) return (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);  return (
    <Container className="container mt-3" style={{ maxWidth: "1462px" }}>
      <h4 className="my-4 fw-bold">Assignments</h4>

      {/* Search Card */}
      <Card className="mb-4 p-3">
        <h4 className="fw-bold">Search Assignment List</h4>
        <Row className="gy-3">
          <Col md={3}>
            <Form.Label>Search by Code/Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter code"
              value={searchFilter.search_key}
              onChange={(e) =>
                setSearchFilter({ ...searchFilter, search_key: e.target.value })
              }
            />
          </Col>

          <Col md={3}>
            <Form.Label>Program</Form.Label>
            <Form.Select
              value={searchFilter.program}
              onChange={(e) =>
                setSearchFilter({ ...searchFilter, program: e.target.value })
              }
            >
              <option value="">Select Program</option>
              {programs.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.program_master_code}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Course Category</Form.Label>
            <Form.Select
              value={searchFilter.courseCategory}
              onChange={handleCourseCategoryChange}
            >
              <option value="">Select Course Category</option>
              {courseCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Semester</Form.Label>
            <Form.Select
              value={searchFilter.semester}
              onChange={(e) =>
                handleSubjectOrSemesterChange("semester", e.target.value)
              }
            >
              <option value="">Select Semester</option>
              {semesters.map((sem) => (
                <option key={sem.id} value={sem.id}>
                  {sem.full_name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Subject</Form.Label>
            <Form.Select
              value={searchFilter.subject}
              onChange={(e) =>
                handleSubjectOrSemesterChange("subject", e.target.value)
              }
            >
              <option value="">Select Subject</option>
              {subjects.map((sub) => (
                <option key={sub.id} value={sub.id}>
                  {sub.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Paper Code</Form.Label>
            <Form.Select
              value={searchFilter.paperCode}
              onChange={(e) =>
                setSearchFilter({ ...searchFilter, paperCode: e.target.value })
              }
            >
              <option value="">Select Paper Code</option>
              {paperCodes.map((pc) => (
                <option key={pc.id} value={pc.id}>
                  {pc.paper_code}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={2} className="d-flex align-items-end">
            <Button
              onClick={() => fetchAssignments(1)}
              variant="primary"
              className="btn btn-primary w-100 w-md-auto"
            >
              <i class="fa-solid fa-magnifying-glass"></i> Search
            </Button>
          </Col>

          <Col md={2} className="d-flex align-items-end">
            <Button
              onClick={handleReset}
              variant="secondary"
              className="btn btn-primary w-100 w-md-auto"
            >
              <i class="fa-solid fa-rotate-left"></i> Reset
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Add Paper Button */}
      <Button
        variant="success"
        className="text-white fw-bold px-4"
        onClick={() => setShowModal(true)}
      >
        Add Assignment <i className="fa-solid fa-plus ms-2"></i>
      </Button>

      {/* Table */}
      <table className="table table-striped table-hover table-responsive mt-4">
        <thead className="table-primary">
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Exam Name</th>
            <th>Subject</th>
            <th>Paper Code</th>
            <th className="text-center">Question Type</th>
            <th className="text-center">Time</th>
            <th className="text-center">Action</th>
            <th className="text-center">Answers</th>

          </tr>
        </thead>
        <tbody>
          {assignments?.map((a,index) => (
            <tr key={a.id}>
              <td>{index + 1}.</td>
              <td>{a.title}</td>
              <td>{a.exam_master_name}</td>
              <td>
                <div>
                  {a.program_master_code} <br />
                  {a.program_category_name} <br />
                  {a.subject_name} <br />
                  {a.semester_name}
                </div>
              </td>
              <td>{a.paper_code}</td>
              <td className="text-center">{a.question_entry_type_name}</td>
              <td className="text-center">
                <div>
                  Start Time: {a.exam_start_time}
                  <br />
                  End Time: {a.exam_end_time}
                </div>
              </td>
              <td className="text-center">
                <Button
                  size="sm"
                  variant="primary"
                  className="me-2"
                  onClick={() => fetchAssignmentsById(a.id)}
                >
                  <i className="fa-solid fa-pencil"></i>
                </Button>
                <Button size="sm" className="btn btn-danger text-white"
                onClick={() => deleteAssignment(a.id)}>
                  <i className="fa-solid fa-trash"></i>
                </Button>
              </td>
              <td class="text-center">
                <Button size="sm" variant="primary" onClick={() => navigateToDetails(a.id)}>
                  <i class="fa-solid fa-clipboard"></i>
                </Button>
              </td>
            </tr>
          )) || (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No assignments found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        size="lg"
        centered
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#5856d6", color: "#fff" }}
        >
          <Modal.Title>Edit Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editData && (
            <Form>
              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Program <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={editData.program || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, program: e.target.value })
                    }
                  >
                    <option value="">Select Program</option>
                    {programs.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.program_master_code}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Course Category <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={editData.program_category || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        program_category: e.target.value,
                        subject: "", // reset subject if category changes
                        exam_paper: "", // reset paper
                      })
                    }
                  >
                    <option value="">Select Course Category</option>
                    {courseCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>

              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Subject <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={editData.subject || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        subject: parseInt(e.target.value),
                        exam_paper: "",
                      })
                    }
                    disabled={!editData.program_category}
                  >
                    <option value="">Select Subject</option>
                    {subjects.map((sub) => (
                      <option key={sub.id} value={sub.id}>
                        {sub.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Semester <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={editData.semester || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, semester: e.target.value })
                    }
                  >
                    <option value="">Select Semester</option>
                    {semesters.map((sem) => (
                      <option key={sem.id} value={sem.id}>
                        {sem.full_name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>

              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Question Entry Type <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={editData.exam_paper_type || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        exam_paper_type: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Type</option>
                    {questionEntryTypes.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Exam <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={editData.exam_master || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        exam_master: e.target.value,
                        exam_paper: "",
                      })
                    }
                  >
                    <option value="">Select Exam</option>
                    {editExamMasters.length > 0 ? (
                      editExamMasters.map((exam) => (
                        <option key={exam.id} value={exam.id}>
                          {exam.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No exams available</option>
                    )}
                  </Form.Select>
                </Col>
              </Row>

              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Exam Paper <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={editData.exam_paper || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, exam_paper: e.target.value })
                    }
                  >
                    <option value="">Select Paper</option>
                    {editExamPapers.length > 0 ? (
                      editExamPapers.map((paper) => (
                        <option key={paper.id} value={paper.id}>
                          {paper.title}
                        </option>
                      ))
                    ) : (
                      <option disabled>No papers available</option>
                    )}
                  </Form.Select>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Exam Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={editData.exam_date || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, exam_date: e.target.value })
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Academic Year <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={editData.academic_year_id || ""}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          academic_year_id: parseInt(e.target.value),
                        })
                      }
                    >
                      <option value="">Select Year</option>
                      {academicYear.map((year) => (
                        <option key={year.id} value={year.id}>
                          {year.academic_year}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Title <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={editData.title || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, title: e.target.value })
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    Start Time <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="time"
                    value={editData.exam_start_time || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        exam_start_time: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fw-bold">
                    End Time <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="time"
                    value={editData.exam_end_time || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        exam_end_time: e.target.value,
                      })
                    }
                  />
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => editAssignment()}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Pagination */}
      <Pagination className="justify-content-center">
        <Pagination.Prev
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        />
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={page === i + 1}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        />
      </Pagination>

      {/* Add Exam Paper Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#5856d6", color: "#fff" }}
        >
          <Modal.Title>Add Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Program <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={formData.program || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, program: e.target.value })
                    }
                  >
                    <option value="">Select Program</option>
                    {programs.map((prog) => (
                      <option key={prog.id} value={prog.id}>
                        {prog.program_master_code}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Course Category <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={formData.course_category_id || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFormData({
                        ...formData,
                        course_category_id: val,
                        subject: "",
                        paper_code_id: "",
                      });
                      fetchSubjects(val);
                    }}
                  >
                    <option value="">Select Course Category</option>
                    {courseCategories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Subject <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={formData.subject || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFormData({
                        ...formData,
                        subject: val,
                        paper_code_id: "",
                      });
                      // Fetch paper codes if semester is already selected
                      if (formData.semester) {
                        // fetchPaperCodes(val, formData.semester_id);
                      }
                    }}
                    disabled={!formData.course_category_id}
                  >
                    <option value="">Select Subject</option>
                    {subjects.map((subj) => (
                      <option key={subj.id} value={subj.id}>
                        {subj.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Semester <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={formData.semester || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFormData({
                        ...formData,
                        semester: val,
                        paper_code_id: "",
                      });

                    }}
                  >
                    <option value="">Select Semester</option>
                    {semesters.map((sem) => (
                      <option key={sem.id} value={sem.id}>
                        {sem.full_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Question Entry Type <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={formData.exam_paper_type || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        exam_paper_type: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Question Entry Type</option>
                    {questionEntryTypes?.map((exam) => (
                      <option key={exam.id} value={exam.id}>
                        {exam.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Select Exam <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={formData.exam_master || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, exam_master: e.target.value })
                    }
                  >
                    <option value="">Select Exam Master</option>
                    {examMastersModal.length > 0 ? (
                      examMastersModal.map((exam) => (
                        <option key={exam.id} value={exam.id}>
                          {exam.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No exam masters available</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Select Exam Paper <span className="text-danger">*</span>
                  </Form.Label>


                  <Form.Select
                    value={formData.exam_paper || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, exam_paper: e.target.value })
                    }
                    disabled={!formData.exam_master} // ✅ disable until exam master is selected
                  >
                    <option value="">Select Exam Paper</option>
                    {examPapers.length > 0 ? (
                      examPapers.map((paper) => (
                        <option key={paper.id} value={paper.id}>
                          {paper.title}
                        </option>
                      ))
                    ) : (
                      <option disabled>No exam papers available</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Select Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.exam_date || today}
                    onChange={(e) =>
                      setFormData({ ...formData, exam_date: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Academic Year <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Select
                    value={formData.academic_year || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        academic_year: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Year</option>
                    {academicYear.map((year) => (
                      <option key={year.id} value={year.id}>
                        {year.academic_year}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Title <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter exam title"
                    value={formData.title} // ✅ bind to state
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Select Start Time <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="time"
                    value={formData.exam_start_time || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        exam_start_time: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Select End Time <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="time"
                    value={formData.exam_end_time || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        exam_end_time: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={addAssignment}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Exam Paper Modal */}
    </Container>
  );
}
